import Reveal from "./ui/Reveal";
import {
    HiOutlineShieldCheck,
    HiOutlineOfficeBuilding,
    HiOutlineHome,
    HiOutlineCheckCircle
} from "react-icons/hi";


const packages = [
    {
        title: "Terreno Seguro",
        icon: <HiOutlineShieldCheck />,
        description: "Formaliza tu terreno antes de vender o construir.",
        services: [
            "Búsqueda Catastral",
            "Subdivisión de Lotes",
            "Regularización ante SUNARP"
        ]
    },
    {
        title: "Proyecto Maestro",
        icon: <HiOutlineOfficeBuilding />,
        description: "Carpeta técnica completa para iniciar tu construcción.",
        services: [
            "Levantamiento Topográfico",
            "Planos de Edificación",
            "Expediente para Licencia"
        ]
    },
    {
        title: "Hogar Legal",
        icon: <HiOutlineHome />,
        description: "Regulariza y formaliza tu vivienda.",
        services: [
            "Independización por Pisos",
            "Declaratoria de Fábrica",
            "Ampliaciones y Remodelaciones"
        ]
    }
];

const ServicePackages = () => {
    return (
        <section className="py-24 bg-gray-50">
            <div className="max-w-7xl mx-auto px-6">

                <Reveal>
                    <h2 className="text-3xl font-bold text-center text-[#1C1C1C]">
                        Soluciones de Regularización de Predios
                    </h2>
                    <p className="text-center text-gray-600 mt-4 max-w-2xl mx-auto">
                        Paquetes de servicios diseñados para formalizar, desarrollar y potenciar tu propiedad.
                    </p>
                </Reveal>

                <div className="grid md:grid-cols-3 gap-10 mt-16">

                    {packages.map((pack, index) => (
                        <Reveal key={index}>
                            <div className="bg-white p-8 rounded-2xl border border-gray-100 shadow-sm hover:shadow-xl transition group hover:-translate-y-2">

                                <h3 className="text-xl font-semibold text-[#1C1C1C] group-hover:text-[#F26B1D] transition">
                                    {pack.title}
                                </h3>

                                <p className="mt-3 text-gray-600">
                                    {pack.description}
                                </p>

                                <ul className="mt-6 space-y-3">

                                    {pack.services.map((service, i) => (
                                        <li key={i} className="flex items-start gap-3 text-gray-600">

                                            <HiOutlineCheckCircle
                                                className="text-[#F26B1D] mt-1"
                                                size={18}
                                            />

                                            <span>{service}</span>

                                        </li>
                                    ))}

                                </ul>

                            </div>
                        </Reveal>
                    ))}

                </div>
            </div>

        </section>
    );
};

export default ServicePackages;